import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import { useForm, useFormState } from 'react-final-form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormRadio from '../../components/FormRadio'
import FormField from '../../components/FormField'

const radioStyle = {
  paddingBottom: 0,
  display: 'none',
}

const radioOverrideMuiStyle = {
  '&.MuiRadio-root': {
    '&.Mui-checked + span': {
      backgroundColor: `primary.main`,
      color: '#FFF !important',
    },
  },
}

const textStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  display: 'inline-flex',
  borderColor: 'primary.main',
  borderWidth: 1,
  borderStyle: 'solid',
  marginTop: 0,
  marginRight: '6px',
  marginBottom: '10px',
  fontWeight: 'bold',
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
  minHeight: 80,
  cursor: 'pointer',
}

const Smoker = ({ validate }: FormSectionProps) => {
  const form = useForm()
  const { values } = useFormState();
  const theme = useTheme()
  //@ts-ignore
  const custom = theme?.custom

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            Have you smoked in the last year?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Please select ‘yes’ even if it‘s just occasionally. That includes
            e-cigarettes and other nicotine-based products.
          </Typography>
          <Grid container spacing={2} sx={{ mb: 14 }}>
            <Grid item xs={12} md={6}>
              <label htmlFor="smoker-yes" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="smoker-yes"
                  name="isSmoker"
                  value={'true'}
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('isSmoker', 'true')
                    // await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Yes
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="smoker-no" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="smoker-no"
                  name="isSmoker"
                  value={'false'}
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('isSmoker', 'false')
                    // await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  No
                </Typography>
              </label>
            </Grid>
          </Grid>

          { custom.apiKey === "2d6fe9fa-ead6-4bb4-b285-90967190067a" ? <>
            { values["isSmoker"] === "false" ? <>
              <Typography variant="body1" sx={{ mb: 2 }}>
              If no, Have you smoked in the last 5 years?
              </Typography>
              <Grid container spacing={2} sx={{ mb: 14 }}>
                <Grid item xs={12} md={6}>
                  <label htmlFor="smokedLast5Years-yes" style={{ textAlign: 'center' }}>
                    <FormRadio
                      id="smokedLast5Years-yes"
                      name="smokedLast5Years"
                      value={'true'}
                      style={radioStyle}
                      overrideMuiStyle={radioOverrideMuiStyle}
                      onClick={async () => {
                        form.change('smokedLast5Years', 'true')
                        // await form.submit()
                      }}
                    />
                    <Typography
                      component="span"
                      sx={{
                        ...textStyle,
                        backgroundColor: lighten(theme.palette.primary.main, 0.8),
                      }}
                    >
                      Yes
                    </Typography>
                  </label>
                </Grid>
                <Grid item xs={12} md={6}>
                  <label htmlFor="smokedLast5Years-no" style={{ textAlign: 'center' }}>
                    <FormRadio
                      id="smokedLast5Years-no"
                      name="smokedLast5Years"
                      value={'false'}
                      style={radioStyle}
                      overrideMuiStyle={radioOverrideMuiStyle}
                      onClick={async () => {
                        form.change('smokedLast5Years', 'false')
                        // await form.submit()
                      }}
                    />
                    <Typography
                      component="span"
                      sx={{
                        ...textStyle,
                        backgroundColor: lighten(theme.palette.primary.main, 0.8),
                      }}
                    >
                      No
                    </Typography>
                  </label>
                </Grid>
              </Grid>
            </> : null }

            { values["isSmoker"] === "false" && values["smokedLast5Years"] === "true" ? <>
              <Typography variant="body1" sx={{ mb: 2 }}>
              If yes, when did you stop smoking?
              </Typography>
              <FormField
                id="whenDidYouStopSmoking"
                name="whenDidYouStopSmoking"
                placeholder=""
                type="text"
              />
            </> : null }
            <br/><br/><br/>
          </> : null }

          <Typography variant="body1" fontSize={16} sx={{ mb: 8 }}>
            Smokers have a higher chance of claiming on their insurance – which
            is why all insurers make this question mandatory. It’s really
            important to be honest, as we don’t want you to be in a situation
            where the insurer is refusing to pay your claim.
          </Typography>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default Smoker
